<ui-avatar
  [uiSize]="size"
  [uiIcon]="badge.icon"
  [uiPattern]="badge.pattern"
  [uiBgColor]="badge.background"
  [uiAlt]="badge.name"
  [uiTooltipTitle]="showTooltip && badge.name"
  [uiTooltipPlacement]="tooltipPlacement"
  ui-tooltip></ui-avatar>
